import { Table, Tag, Space, Collapse } from "antd";
import React, { useState, useMemo, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CheckCircleOutlined, CloseCircleOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import './AccordionContent.css';
import ExFactoryDate from "../Table/ExFactoryDate/ExFactoryDate";
import DateSentReceive from "../Table/DateSentRec/DateSentRec";
import QtyReqRec from "../Table/QtyReqRec/QtyReqRec";
import Brand from "../Table/Brand/Brand";
import Design from "../Table/Design/Design";
import PD from "../Table/PD/PD";
import QA from "../Table/QA/QA";
import Request from "../Table/Request/Request";
import GreenTag from "../../../images/green-tag.png";
import { changingTabsWithCustomButton } from "../../../Redux/actions/Dashboard/Dashboard";
import { resetSrfSearchData } from "../../../Redux/actions/Srf/Srf";
import { useNavigate } from "react-router-dom";
const AccordionContent = ({ itemData, selectedRow, parentSelected, intialSearchData }) => {
  const vendor = itemData?.vendors;
  const status = itemData?.vendor_status;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [selectedVendorIndex, setSelectedVendorIndex] = useState([]);
  const [innerSelectedRowKeys, setInnerSelectedRowKeys] = useState([]);

  const selectedVendorStorageKey = useMemo(
    () =>
      itemData?.style
        ? `srtSelectedVendors_${itemData?.brand || ""}_${itemData?.season || ""}_${itemData?.style}`
        : "",
    [itemData?.brand, itemData?.season, itemData?.style]
  );

  const saveSelectedVendors = (vendorIndexes) => {
    if (!selectedVendorStorageKey) return;

    const vendorNames = vendorIndexes
      .map((index) => vendor?.[index]?.name)
      .filter(Boolean);

    if (vendorNames.length) {
      localStorage.setItem(
        selectedVendorStorageKey,
        JSON.stringify(vendorNames)
      );
    } else {
      localStorage.removeItem(selectedVendorStorageKey);
    }
  };

  const toggleVendor = (index) => {
    setInnerSelectedRowKeys([]);
    localStorage.removeItem("srtSelectedExportKeys");
    setSelectedVendorIndex(prev => {
      const isSelected = prev.includes(index);
      const nextSelectedVendorIndex = isSelected
        ? prev.filter(i => i !== index)
        : [...prev, index];

      saveSelectedVendors(nextSelectedVendorIndex);

      if (isSelected) {
        return nextSelectedVendorIndex;
      }
      return nextSelectedVendorIndex;
    });
  };

  const onInnerSelectChange = (newSelectedRowKeys, selectedRecords) => {
    setInnerSelectedRowKeys(newSelectedRowKeys);
    const selectedSamplePids = selectedRecords
      .map((record) => record?.sample_pid)
      .filter(Boolean);

    localStorage.setItem("srtSelectedExportKeys", JSON.stringify(selectedSamplePids));
  };

  const innerRowSelection = {
    selectedRowKeys: innerSelectedRowKeys,
    onChange: onInnerSelectChange,
    checkStrictly: true
  };
  const selectedVendors = selectedVendorIndex.map(i => vendor?.[i]).filter(Boolean);

  const vendorSpecificData = useMemo(() => {
    if (selectedVendorIndex.length === 0 || !itemData) return [];

    const allData = intialSearchData || [];
    const rows = [];
    selectedVendorIndex.forEach(idx => {
      const selectedVendor = vendor[idx];
      if (!selectedVendor) return;

      const filteredData = allData.filter(item =>
        item.style === itemData?.style &&
        item.factory === selectedVendor.name
      );

      filteredData.forEach(item => {
        rows.push({
          key: `${item.sample_pid}`,
          ...item,
          request_details: item.request_details || [],
        });
      });
    });

    return rows;
  }, [selectedVendorIndex, itemData, intialSearchData, vendor]);

  useEffect(() => {
    if (!vendor?.length) return;
    if (parentSelected) {
      const allVendorIndexes = vendor.map((_, index) => index);
      setSelectedVendorIndex(allVendorIndexes);
      return;
    }

    if (!selectedVendorStorageKey) return;

    let savedVendorNames = [];
    try {
      savedVendorNames = JSON.parse(
        localStorage.getItem(selectedVendorStorageKey) || "[]"
      );
    } catch {
      savedVendorNames = [];
    }

    if (!savedVendorNames.length) return;

    const restoredVendorIndexes = vendor
      .map((vendorItem, index) =>
        savedVendorNames.includes(vendorItem?.name) ? index : null
      )
      .filter((index) => index !== null);

    if (restoredVendorIndexes.length) {
      setSelectedVendorIndex(restoredVendorIndexes);
    }
  }, [parentSelected, selectedVendorStorageKey, vendor]);

  useEffect(() => {
    if (parentSelected && vendorSpecificData.length > 0) {
      const allKeys = vendorSpecificData.map((item) => item.key);
      setInnerSelectedRowKeys(allKeys);
    }
  }, [parentSelected, vendorSpecificData]);

  useEffect(() => {
    if (!parentSelected) {
      setInnerSelectedRowKeys([]);
    }
  }, [parentSelected]);

  const getRequestRowClass = (index, details = []) =>
    `request-detail-row ${index < details.length - 1 ? "request-detail-row-bordered" : ""
    }`;

  // Main Table Columns
  const mainColumns = [
    {
      title: "Factory",
      key: "group_info",
      width: "5%",
      render: (_, record) => (
        <div className="season-wrapper">
          <div>
            {/* <p style={{ fontWeight: "600", color: "#0c3d5e", whiteSpace: "nowrap" }}>
              Promised Ex-Factory
            </p> */}
            <p style={{ marginBottom: 2 }}>
              {record?.request_details?.[0]?.req_exfactory}
            </p>
          </div>
          <div>
          </div>

          <p className={`vendorName ${itemData?.isRedevelopmentVendor === true ? "red" : "blue"}`}
            style={{ marginTop: 4, cursor: "pointer" }}
            onClick={() => {
              localStorage.setItem("DashboardData", JSON.stringify({
                style: itemData?.style,
                factory: record?.factory,
                season: itemData?.season,
                brand: itemData?.brand,
              }));
              localStorage.removeItem("srtMassData");
              localStorage.removeItem("massFilterData");
              dispatch(resetSrfSearchData([]));
              localStorage.setItem("RequestSend", false);
              dispatch(changingTabsWithCustomButton("true.2"));
              localStorage.removeItem("SrfSearchData");
              navigate("/sample-request-form");
            }}
          >

            {record?.factory}
          </p>
        </div>
      ),
      // ★ No onCell rowSpan needed — it's already one row per style
    },
    {
      title: "Color",
      key: "color",
      width: "10%",
      render: (_, record) => (
        <div>
          {/* <p style={{ fontWeight: "600", color: "#0c3d5e", }}>Color</p> */}
          <p style={{ margin: 0 }}>{record?.color_code}
            <span>{record?.is_new_colorkey && (
              <img width={15} height={15} src={GreenTag} alt="Tag" style={{ marginLeft: 6, position: "relative", top: 2 }} />
            )}
            </span>
          </p>
        </div>
      )
    },
    {
      title: "Size",
      key: "size",
      width: "10%",
      render: (_, record) => (
        <div>
          {/* <p style={{ fontWeight: "600", color: "#0c3d5e", }}>Size</p> */}
          <p style={{ margin: 0 }}>{record?.size}</p>
        </div>
      )
    },
    {
      title: "Request",
      key: "request",
      width: "10%",
      render: (_, record) => (
        <div className="request-detail-stack">
          {record.request_details.map((detail, i) => (
            <div
              key={`${record.sample_pid}_${detail?.request_no}_request`}
              className={getRequestRowClass(i, record.request_details)}
            >
              <Request request={detail?.request_no} />
            </div>
          ))}
        </div>
      )
    },
    {
      title: "Ex-Factory Date Req/Promised",
      key: "ex_factory",
      width: "12%",
      render: (_, record) => (
        <div className="request-detail-stack">
          {record.request_details.map((detail, i) => (
            <div
              key={`${record.sample_pid}_${detail?.request_no}_ex_factory`}
              className={getRequestRowClass(i, record.request_details)}
            >
              <ExFactoryDate
                requestDate={detail?.req_exfactory}
                createdDate={detail?.created_date || record?.created_date}
                requestRecievedDate={detail?.promised_exfactory}
                dataOfReq={detail}
                itemData={record}
                salesSample="0"
                dataOfRow={record}
              />
            </div>
          ))}
        </div>
      )
    },
    {
      title: (
        <div style={{ textAlign: "center" }}>
          Date
          <br />
          Sent/Rec
        </div>
      ),
      key: "sent_received",
      width: "12%",
      render: (_, record) => (
        <div className="request-detail-stack">
          {record.request_details.map((detail, i) => {
            const requestKey = `${record.sample_pid}_${detail?.request_no}_sent_received`;
            return (
              <div
                key={requestKey}
                className={getRequestRowClass(i, record.request_details)}
              >
                <DateSentReceive
                  reqNo={detail?.request_no}
                  createdDate={detail?.created_date || record?.created_date}
                  dataOfReq={detail}
                  recieveDate={detail?.request_date}
                  requestRecievedDate={detail?.request_recieved}
                  itemData={record}
                  salesSample="0"
                  dataOfRow={record}
                />
              </div>
            );
          })}
        </div>
      )
    },
    {
      title: (
        <div style={{ textAlign: "center" }}>
          Qty
          <br />
          Req/Rec
        </div>
      ),
      key: "qty",
      width: "10%",
      render: (_, record) => (
        <div className="request-detail-stack">
          {record.request_details.map((detail, i) => {
            const requestKey = `${record.sample_pid}_${detail?.request_no}_qty`;
            return (
              <div
                key={requestKey}
                className={getRequestRowClass(i, record.request_details)}
              >
                <QtyReqRec
                  data={detail}
                  user={detail?.user}
                  promisedDate={detail?.promised_exfactory}
                  requestRecievedDate={detail?.request_recieved}
                  qtyReciever={detail?.Qty}
                  qtyRecieved={detail?.QtyRcd}
                  commentReciever={detail?.quantity_cmt}
                  dataOfRow={record}
                  dataOfReq={detail}
                  reqNo={detail?.request_no}
                  itemData={record}
                  salesSample="0"
                />
              </div>
            );
          })}
        </div>
      )
    },
    {
      title: "Brand",
      key: "brand",
      width: "10%",
      render: (_, record) => (
        <div className="request-detail-stack">
          {record.request_details.map((detail, i) => (
            <div
              key={`${record.sample_pid}_${detail?.request_no}_brand`}
              className={getRequestRowClass(i, record.request_details)}
            >
              <Brand
                user={detail?.user}
                data={detail}
                brandStatus={detail?.brand_status}
                statusFor="brand"
                dataOfRow={record}
                reqNo={detail?.request_no}
                commentReciever={detail?.brand_cmt}
                salesSample="0"
              />
            </div>
          ))}
        </div>
      )
    },
    {
      title: "Design",
      key: "design",
      width: "10%",
      render: (_, record) => (
        <div className="request-detail-stack">
          {record.request_details.map((detail, i) => (
            <div
              key={`${record.sample_pid}_${detail?.request_no}_design`}
              className={getRequestRowClass(i, record.request_details)}
            >
              <Design
                user={detail?.user}
                data={detail}
                designStatus={detail?.design_status}
                statusFor="design"
                dataOfRow={record}
                reqNo={detail?.request_no}
                commentReciever={detail?.design_cmt}
                salesSample="0"
              />
            </div>
          ))}
        </div>
      )
    },
    {
      title: "PD",
      key: "pd",
      width: "8%",
      render: (_, record) => (
        <div className="request-detail-stack">
          {record.request_details.map((detail, i) => (
            <div
              key={`${record.sample_pid}_${detail?.request_no}_pd`}
              className={getRequestRowClass(i, record.request_details)}
            >
              <PD
                user={detail?.user}
                data={detail}
                pdStatus={detail?.pd_status}
                dataOfRow={record}
                statusFor="pd"
                reqNo={detail?.request_no}
                commentReciever={detail?.pd_cmt}
                salesSample="0"
              />
            </div>
          ))}
        </div>
      )
    },
    {
      title: "QA",
      key: "qa",
      width: "8%",
      render: (_, record) => (
        <div className="request-detail-stack">
          {record.request_details.map((detail, i) => (
            <div
              key={`${record.sample_pid}_${detail?.request_no}_qa`}
              className={getRequestRowClass(i, record.request_details)}
            >
              <QA
                user={detail?.user}
                data={detail}
                qaStatus={detail?.qa_status}
                dataOfRow={record}
                statusFor="qa"
                reqNo={detail?.request_no}
                commentReciever={detail?.qa_cmt}
                salesSample="0"
              />
            </div>
          ))}
        </div>
      )
    }
  ];

  return (
    <div className="srt-accordion-content">
      <div className="vendor-container">
        <div className="srt-accordion-vendor-list">
          <div style={{ display: "flex", gap: 20, flexWrap: "wrap" }}>
            {vendor?.map((vendorItem, index) => {
              const checked = selectedVendorIndex.includes(index);
              return (
                <label
                  key={index}
                  className={`vendor-card ${checked ? "active" : ""}`}
                  onClick={() => toggleVendor(index)}
                  style={{ cursor: "pointer" }}
                >
                  <span className={`checkbox-box ${checked ? "checked" : ""}`}>
                    {checked && <span className="checkbox-tick">✓</span>}
                  </span>
                  <div className="vendor-text">
                    <p className={`vendorName ${itemData?.isRedevelopmentVendor === true ? "red" : "blue"}`}>
                      {vendorItem.name}
                    </p>
                    <div className="vendorRole">
                      ({vendorItem.status})
                    </div>
                  </div>
                </label>
              );
            })}
          </div>
        </div>

        {selectedVendors.length > 0 && vendorSpecificData.length > 0 && (
          <div className="vendor-details">
            <Table
              columns={mainColumns}
              rowSelection={innerRowSelection}
              dataSource={vendorSpecificData}
              pagination={false}
              size="small"
              className="vendor-detail-table"
              rowKey="key"
            />
          </div>
        )}

        {selectedVendors.length > 0 && vendorSpecificData.length === 0 && (
          <div className="no-data-message">
            <ExclamationCircleOutlined style={{ fontSize: "24px", color: "#faad14", marginBottom: "8px" }} />
            <p>No data available for {selectedVendors.map(v => v?.name).join(", ")}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default AccordionContent;
